import { createFileRoute } from "@tanstack/react-router";
import { Users, Lock } from "lucide-react";
import { openWhatsAppContact, WHATSAPP_CONTACT_NAME } from "@/lib/whatsapp-contact";


export const Route = createFileRoute("/_authenticated/app/team")({
  component: TeamPage,
});

function TeamPage() {
  // Placeholder UI - full team management ships with the Studio plan rollout.
  return (
    <div className="mx-auto w-full max-w-4xl px-4 py-8 sm:px-6">
      <header className="mb-8">
        <h1 className="font-display text-3xl font-semibold tracking-tight">Team</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Gestisci membri, ruoli e inviti del tuo studio.
        </p>
      </header>

      <div className="rounded-2xl border border-border bg-card p-8 text-center">
        <div className="mx-auto inline-flex h-12 w-12 items-center justify-center rounded-full bg-muted">
          <Lock className="h-5 w-5 text-muted-foreground" />
        </div>
        <h2 className="mt-5 font-display text-xl font-semibold">
          Disponibile sul piano Studio
        </h2>
        <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
          La gestione del team - inviti, ruoli (Admin / Member), SSO aziendale - è inclusa nel
          piano Studio. Contattaci per attivarla per il tuo studio.
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => openWhatsAppContact("Ciao Gianluca, vorrei attivare il piano Studio di LexAI Pro per il mio studio.")}
            className="inline-flex h-10 items-center gap-2 rounded-full bg-foreground px-5 text-sm font-medium text-background hover:opacity-90"
          >
            <Users className="h-4 w-4" />
            Contatta {WHATSAPP_CONTACT_NAME} su WhatsApp
          </button>
        </div>

      </div>
    </div>
  );
}
